/**
 * Подпись поля — один рецепт на оба продукта: 13 px, вес 500, основной цвет.
 *
 * `id` понадобился строке-пикеру общего слоя формы заявки: у неё контрол — `<button>`, а
 * `htmlFor`, наведённый на кнопку, ЗАМЕНЯЕТ её доступное имя вместо того, чтобы дополнить.
 * Кнопка «Выберите из своих контейнеров» перестала бы так называться. Поэтому там подпись
 * связывается через `aria-labelledby`, и ей нужно имя, за которое можно взяться.
 */
export function FieldLabel({
  id,
  htmlFor,
  label,
  required,
}: {
  id?: string;
  htmlFor?: string;
  label?: string;
  required?: boolean;
}): JSX.Element | null {
  if (!label) return null;

  return (
    <label
      id={id}
      htmlFor={htmlFor}
      className="block text-sm font-medium text-[var(--color-text-primary)] mb-1"
    >
      {label}
      {required && <span className="text-[var(--color-error)] ml-1">*</span>}
    </label>
  );
}
